import { render, staticRenderFns } from "./DrawRequests.vue?vue&type=template&id=bb224aca"
import script from "./DrawRequests.vue?vue&type=script&lang=js"
export * from "./DrawRequests.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports